module.exports = __webpack_public_path__ + "static/form-3-5402dae27c42424103e2ca6310a93c86.jpg";